import { profileIndicator } from './profileIndicator.model';

export class ProfileNode {
  name: string;
  id: number;
  weight: any;
  effectiveWeight: any;
  children: ProfileNode[];
  expandable: boolean;
  dropdownOptions: profileIndicator[];
  filteredOptions: profileIndicator[];
  isSupplyGroup: boolean;
  isOccupationGroup: boolean;
  isCostGroup: boolean;
  isDegreeCompletionGroup: boolean;
  isCompetitionResearchGroup: boolean;
  isSkillsGroup: boolean;
  degrees: any;
  filteredDegrees: any;
  secondDropdownOptions: profileIndicator[];
  secondDropdownFilteredOptions: profileIndicator[];
  secondName: string;
  groupCustomName: string;
  validationFailure: boolean;
  nodeId: string;
  indicatorType: string;
  isLeafNode: boolean;
  countryId?: number;
}
